<mibi-box-layout>
    <div class="mibi-wot">
        <div class="mibi-wot__margin"></div>
        <div class="mibi-wot__content">
            <h1 class="mibi-wot-title">{{ wotTitle }}</h1>
            <div class="mibi-wot-preamble">
                <div class="mibi-wot-preamble__margin"></div>
                <div class="mibi-wot-preamble__content">
                    <ng-content select="[mibi-wot-preamble]"></ng-content>
                </div>
                <div class="mibi-wot-preamble__margin"></div>
            </div>
            <div>
                <ng-content select="[mibi-wot-content]"></ng-content>
            </div>
        </div>
        <div class="mibi-wot__margin"></div>
    </div>
</mibi-box-layout>
